import PropTypes from 'prop-types'
import { useState } from 'react'
import ReactPlayer from 'react-player'

import Block from './Block'

function BlockVideo({ block, nextBlock, isLastBlock, upNextTitle }) {
  const [canProceed, setCanProceed] = useState(
    ['Completed', 'Quiz Pending'].includes(block.status),
  )

  // Video assets either host an uploaded file (signed S3 URL) or link out to a
  // platform like YouTube. External links play through react-player; uploads use
  // the native player. Either way, finishing the video unlocks proceeding.
  const { videoUrl, signedFilePath } = block.content

  return (
    <Block
      canProceed={canProceed}
      nextBlock={nextBlock}
      title={block.content.name ?? 'Video'}
      block={block}
      isLastBlock={isLastBlock}
      upNextTitle={upNextTitle}
    >
      <div className="grid h-full place-items-center">
        {videoUrl ? (
          <div className="aspect-video w-full max-w-4xl border-2 bg-black">
            <ReactPlayer
              src={videoUrl}
              controls
              width="100%"
              height="100%"
              onEnded={() => setCanProceed(true)}
            />
          </div>
        ) : (
          // eslint-disable-next-line jsx-a11y/media-has-caption
          <video
            autoPlay
            muted
            playsInline
            controls
            controlsList="nodownload noremoteplayback"
            disablePictureInPicture
            className="aspect-video border-2 bg-black object-contain"
            onEnded={() => setCanProceed(true)}
          >
            <source src={signedFilePath} />
            Download the
            <a href={signedFilePath}>Video</a>
          </video>
        )}
      </div>
    </Block>
  )
}

export default BlockVideo

BlockVideo.propTypes = {
  block: PropTypes.object.isRequired,
  nextBlock: PropTypes.func.isRequired,
  isLastBlock: PropTypes.bool,
  upNextTitle: PropTypes.string,
}
